import {
  accessToRGSServices,
  accessToRGSServicesNamespaces,
} from './access-to-rgs-services';
import { accessToSRG, accessToSRGNamespaces } from './access-to-srg';
import { actPage, actPageNamespaces } from './act-page';
import {
  actSuccessAlert,
  actSuccessAlertNamespaces,
} from './act-success-alert';
import { actsList, actsListNamespaces } from './acts-list';
import {
  advertisingBanner,
  advertisingBannerNamespaces,
} from './advertising-banner';
import {
  agentBankDetails,
  agentBankDetailsNamespaces,
} from './agent-bank-details';
import {
  agentBankDetailsForm,
  agentBankDetailsFormNamespaces,
} from './agent-bank-details-form';
import { agentContract, agentContractNamespaces } from './agent-contract';
import {
  agentContractAgreements,
  agentContractAgreementsNamespaces,
} from './agent-contract-agreements';
import {
  agentContractAlert,
  agentContractAlertNamespaces,
} from './agent-contract-alert';
import {
  agentEmploymentDetails,
  agentEmploymentDetailsNamespaces,
} from './agent-employment-details';
import { agentNotFound, agentNotFoundNamespaces } from './agent-not-found';
import { agentProfile, agentProfileNamespaces } from './agent-profile';
import { agentSales, agentSalesNamespaces } from './agent-sales';
import { agentAddress, agentAddressNamespaces } from './agents-address';
import {
  agentAddressForm,
  agentAddressFormNamespaces,
} from './agents-address-form';
import { agreements, agreementsNamespaces } from './agreements';
import { bankDetails, bankDetailsNamespaces } from './bank-details';
import { candiateAuth, candiateAuthNamespaces } from './candidate-auth';
import {
  candiateContract,
  candiateContractNamespaces,
} from './candidate-contract';
import { common, commonNamespaces } from './common';
import {
  completeContractIsNotAvailable,
  completeContractIsNotAvailableNamespaces,
} from './complete-contract-is-not-available';
import { contacts, contactsNamespaces } from './contacts';
import {
  contractCreatedForm,
  contractCreatedFormNamespaces,
} from './contract-created-form';
import { contractOtp, contractOtpNamespaces } from './contract-otp';
import {
  contractSuccessAlert,
  contractSuccessAlertNamespaces,
} from './contract-success-alert';
import {
  contractTerminationSubmitErrorAlert,
  contractTerminationSubmitErrorAlertNamespaces,
} from './contract-termination-submit-error-alert';
import {
  contractTerminationSubmitSuccessAlert,
  contractTerminationSubmitSuccessAlertNamespaces,
} from './contract-termination-submit-success-alert';
import { employment, employmentNamespaces } from './enployment';
import { exportSales, exportSalesNamespaces } from './export-sales';
import { loading, loadingNamespaces } from './loading';
import { login, loginNamespaces } from './login';
import { mainPage, mainPageNamespaces } from './main-page';
import { mainPageNamespaces_2, mainPage_2 } from './main-page_2';
import { otp, otpNamespaces } from './otp';
import { password, passwordNamespaces } from './password';
import {
  passwordRecovery,
  passwordRecoveryNamespaces,
} from './password-recovery';
import {
  personaConfirmation,
  personaConfirmationNamespaces,
} from './persona-confirmation';
import {
  personalDocuments,
  personalDocumentsNamespaces,
} from './personal-documents';
import {
  prepareDocumentForSignNamespaces,
  prepareDocumentsForSign,
} from './prepare-documents-for-sign';
import { products, productsNamespaces } from './products';
import {
  profileEditSubmitErrorAlert,
  profileEditSubmitErrorAlertNamespaces,
} from './profile-edit-submit-error-alert';
import {
  profileEditSubmitSuccessAlert,
  profileEditSubmitSuccessAlertNamespaces,
} from './profile-edit-submit-success-alert';
import { registration, registrationNamespaces } from './registration';
import {
  registrationContractExpired,
  registrationContractExpiredNamespaces,
} from './registration-contract-expired';
import {
  registrationContractSign,
  registrationContractSignNamespaces,
} from './registration-contract-sign';
import { registrationOtp, registrationOtpNamespaces } from './registration-otp';
import {
  registrationQuestionary,
  registrationQuestionaryNamespaces,
} from './registration-questionary';
import { securityPending, securityPendingNamespaces } from './security-pending';
import {
  securityQuestionnaire,
  securityQuestionnaireNamespaces,
} from './security-questionnaire';
import { setPeriod, setPeriodNamespaces } from './set-period';
import {
  showAgentContract,
  showAgentContractNamespaces,
} from './show-agent-contract';
import {
  signUnilaterally,
  signUnilaterallyNamespaces,
} from './sign-unilaterally';
import { smsIsSentAlert, smsIsSentAlertNamespaces } from './sms-is-sent-alert';
import { standards, standardsNamespaces } from './standards';
import { statusesInfo, statusesInfoNamespaces } from './statuses-info';
import {
  subscriptionCreatedAlert,
  subscriptionCreatedAlertNamespaces,
} from './subscription-created-alert';
import {
  subscriptionErrorAlert,
  subscriptionErrorAlertNamespaces,
} from './subscription-error-alert';
import {
  terminateContract,
  terminateContractNamespaces,
} from './terminate-contract';
import {
  unableToContinueRegistrationBlock,
  unableToContinueRegistrationBlockNamespaces,
} from './unable-to-continue-registration-block';
import { verificationNamespaces_2, verification_2 } from './verification_2';
import { welcomePage, welcomePageNamespaces } from './welcome-page';
import { welcomePageNamespaces_2, welcomePage_2 } from './welcome-page_2';

export {
  prepareDocumentForSignNamespaces,
  prepareDocumentsForSign,
} from './prepare-documents-for-sign';

export const resources = {
  ru: {
    ...common,
    ...login,
    ...password,
    ...registration,
    ...registrationContractExpired,
    ...registrationContractSign,
    ...registrationQuestionary,
    ...securityPending,
    ...agreements,
    ...otp,
    ...passwordRecovery,
    ...agentContractAlert,
    ...agentAddress,
    ...agentAddressForm,
    ...contractSuccessAlert,
    ...contractCreatedForm,
    ...agentContractAgreements,
    ...showAgentContract,
    ...agentContract,
    ...personalDocuments,
    ...personaConfirmation,
    ...agentBankDetails,
    ...agentBankDetailsForm,
    ...agentEmploymentDetails,
    ...registrationOtp,
    ...contractOtp,
    ...mainPage,
    ...subscriptionCreatedAlert,
    ...subscriptionErrorAlert,
    ...agentProfile,
    ...products,
    ...contacts,
    ...statusesInfo,
    ...loading,
    ...agentSales,
    ...actsList,
    ...actSuccessAlert,
    ...setPeriod,
    ...exportSales,
    ...actPage,
    ...advertisingBanner,
    ...completeContractIsNotAvailable,
    ...accessToSRG,
    ...standards,
    ...smsIsSentAlert,
    ...agentNotFound,
    ...profileEditSubmitSuccessAlert,
    ...profileEditSubmitErrorAlert,
    ...terminateContract,
    ...contractTerminationSubmitErrorAlert,
    ...contractTerminationSubmitSuccessAlert,
    ...signUnilaterally,
    ...candiateAuth,
    ...candiateContract,
    ...welcomePage,
    ...welcomePage_2,
    ...verification_2,
    ...securityQuestionnaire,
    ...accessToRGSServices,
    ...unableToContinueRegistrationBlock,
    ...mainPage_2,
    ...employment,
    ...bankDetails,
    ...prepareDocumentsForSign,
  },
};

export const namespaces = [
  ...commonNamespaces,
  ...loginNamespaces,
  ...passwordNamespaces,
  ...registrationNamespaces,
  ...registrationContractExpiredNamespaces,
  ...registrationContractSignNamespaces,
  ...registrationQuestionaryNamespaces,
  ...securityPendingNamespaces,
  ...agreementsNamespaces,
  ...otpNamespaces,
  ...passwordRecoveryNamespaces,
  ...agentContractAlertNamespaces,
  ...agentAddressNamespaces,
  ...agentAddressFormNamespaces,
  ...contractSuccessAlertNamespaces,
  ...contractCreatedFormNamespaces,
  ...agentContractAgreementsNamespaces,
  ...showAgentContractNamespaces,
  ...agentContractNamespaces,
  ...personalDocumentsNamespaces,
  ...personaConfirmationNamespaces,
  ...agentBankDetailsNamespaces,
  ...agentBankDetailsFormNamespaces,
  ...agentEmploymentDetailsNamespaces,
  ...registrationOtpNamespaces,
  ...contractOtpNamespaces,
  ...mainPageNamespaces,
  ...subscriptionCreatedAlertNamespaces,
  ...subscriptionErrorAlertNamespaces,
  ...agentProfileNamespaces,
  ...productsNamespaces,
  ...contactsNamespaces,
  ...statusesInfoNamespaces,
  ...loadingNamespaces,
  ...agentSalesNamespaces,
  ...actsListNamespaces,
  ...actSuccessAlertNamespaces,
  ...setPeriodNamespaces,
  ...exportSalesNamespaces,
  ...actPageNamespaces,
  ...advertisingBannerNamespaces,
  ...completeContractIsNotAvailableNamespaces,
  ...accessToSRGNamespaces,
  ...standardsNamespaces,
  ...smsIsSentAlertNamespaces,
  ...agentNotFoundNamespaces,
  ...profileEditSubmitSuccessAlertNamespaces,
  ...profileEditSubmitErrorAlertNamespaces,
  ...terminateContractNamespaces,
  ...contractTerminationSubmitErrorAlertNamespaces,
  ...contractTerminationSubmitSuccessAlertNamespaces,
  ...signUnilaterallyNamespaces,
  ...candiateAuthNamespaces,
  ...candiateContractNamespaces,
  ...welcomePageNamespaces,
  ...welcomePageNamespaces_2,
  ...verificationNamespaces_2,
  ...securityQuestionnaireNamespaces,
  ...accessToRGSServicesNamespaces,
  ...unableToContinueRegistrationBlockNamespaces,
  ...mainPageNamespaces_2,
  ...employmentNamespaces,
  ...bankDetailsNamespaces,
  ...prepareDocumentForSignNamespaces,
];
